import { BrowserNames } from "../../../types";
import { useTranslationsContext } from "../../../contexts/TranslationsContext";
import { detectBrowser } from "../../../helpers";

import chrInstallAppDe from "../../../assets/photos/chr-install-app-de.png";
import sriInstallAppDe from "../../../assets/photos/sri-install-app-de.png";
import frxInstallDe from "../../../assets/photos/frx-install-de.png";

function StepThree(): JSX.Element {
  const { translation } = useTranslationsContext();
  const browser: BrowserNames = detectBrowser();

  const textMap: Record<string, string> = {
    [BrowserNames.CHROME]: translation.INSTALL_APP_STEP_3_CHROME.defaultMessage,
    [BrowserNames.FIREFOX]: translation.INSTALL_APP_STEP_3_FIREFOX.defaultMessage,
    [BrowserNames.SAFARI]: translation.INSTALL_APP_STEP_3_SAFARI.defaultMessage,
  };

  const imgMap: Record<string, { src: string; className: string }> = {
    [BrowserNames.CHROME]: { src: chrInstallAppDe, className: "chr-install-app" },
    [BrowserNames.FIREFOX]: { src: frxInstallDe, className: "frx-install-app" },
    [BrowserNames.SAFARI]: { src: sriInstallAppDe, className: "sri-install" },
  };

  const text = textMap[browser];
  const img = imgMap[browser];

  if (!text || !img) return <></>;

  return (
    <div className="ath-step-content">
      <span className="ath-step-number">3</span>
      <p className="ath-step-text">{text}</p>
      <p className="ath-step-success">
        {translation.INSTALL_APP_STEP_3_SUCCESS.defaultMessage}
      </p>
      <div className="ath-img-card">
        <img className={img.className} src={img.src} alt="Step 3" />
      </div>
    </div>
  );
}

export default StepThree;
